module.exports = __webpack_public_path__ + "static/media/mybb-img2.e6110185.svg";